import React from 'react'
import {Table, TableContainer, Td, Th, Tr} from "../../../common"


const BySourceTable = ({data, dateArray}) => {

  return (
    <TableContainer paddingTop={'10px'}>
      <Table>
        <thead>
        <tr>
          <Td report/>
          <Th dataCy={`title-source`} report> Sorgente </Th>
          {
            dateArray && dateArray.map(date => <Th report key={date} dataCy={`title-${date}`}> {date} </Th>)
          }
          <Th dataCy={`title-total`} report> Totale </Th>
        </tr>
        </thead>
        <tbody data-cy={'report-table'}>
        {
          data && data.map(reportRow => (
            <Tr key={reportRow.Source} data-cy={`report-row-${reportRow.Source}`}>
              <Td report/>
              <Td dataCy={'source'} report>{reportRow.Source || '-'}</Td>
              {
                dateArray && dateArray
                  .map(date =>
                    <Td key={`${reportRow.Source}-${date}`} dataCy={`${reportRow.Source}-${date}`}>
                      {reportRow[date] || '0'}
                    </Td>)
              }
              <Td dataCy={`total`} report> {reportRow['Totale'] || '0'}  </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  )


}

export default BySourceTable